import script from "./problemChoice_eval2.vue?vue&type=script&setup=true&lang=js"
export * from "./problemChoice_eval2.vue?vue&type=script&setup=true&lang=js"

import "./problemChoice_eval2.vue?vue&type=style&index=0&id=f97cfb66&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f97cfb66"]])

export default __exports__